import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initUTMTracking } from "@/utils/utm";

// Capture UTM parameters on first load so they survive across navigation
initUTMTracking();

// Suppress PostHog and other external analytics errors that don't affect app functionality
const originalError = console.error;
console.error = (...args) => {
  // Suppress PostHog related errors
  if (args[0]?.toString?.().includes('postMessage') || 
      args[0]?.toString?.().includes('PostHog') ||
      args[0]?.toString?.().includes('posthog') ||
      args[0]?.toString?.().includes('DataCloneError') ||
      args[0]?.toString?.().includes('PerformanceServerTiming')) {
    return;
  }
  originalError.apply(console, args);
};

// Global error handler for uncaught errors from external scripts
window.addEventListener('error', (event) => {
  if (event.message?.includes('postMessage') || 
      event.message?.includes('PostHog') ||
      event.message?.includes('DataCloneError') ||
      event.message?.includes('PerformanceServerTiming') ||
      event.filename?.includes('posthog')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Handle unhandled promise rejections from external scripts
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('postMessage') ||
      event.reason?.message?.includes('PostHog') ||
      event.reason?.message?.includes('DataCloneError')) {
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
